import FilledButton from "../../../component/FilledButton";
import { Form } from "antd";
import { rules } from "../../../siteData/rules";
import { useEffect } from "react";

const AddSkillPop = ({ handleAddDegree, handleChange, categoryData, handleModalClose, setFormRef }) => {
    const [form] = Form.useForm();
    form.setFieldsValue(categoryData);

    useEffect(() => {
        setFormRef(form);
    }, []);

    return (
        <div className="modal_body">
            <Form
                form={form}
                name="register"
                onFinish={(e) => handleAddDegree(e, form)}
                scrollToFirstError
                className="attached_courses-add_skill"
            >
                <h2>add degree name</h2>
                <Form.Item name="type" rules={rules.degreeName} className="form_group">
                    <input autoComplete={"off"} name='type' onChange={handleChange} value={categoryData.type} name="type" type="text" className="form_control" autoFocus />
                </Form.Item>
                <div className="form_group form_footer">
                    <FilledButton onClick={() => handleModalClose()} type="reset" className="btn btn_gray" value="Cancel" />
                    <FilledButton type="submit" className="btn btn_primary" value="submit" />
                </div>
            </Form>
        </div>
    )
};

export default AddSkillPop;